export const REQUESTS_VERIFI_INFORM_SLICE_NAME = "requestsVerifiInform"
